import axios from "axios";

export const api = axios.create({
    baseURL : 'https://frmk-organic.netlify.app/api',
})
